import { render, staticRenderFns } from "./Google.vue?vue&type=template&id=073eddfa&scoped=true"
import script from "./Google.vue?vue&type=script&lang=js"
export * from "./Google.vue?vue&type=script&lang=js"
import style0 from "./Google.vue?vue&type=style&index=0&id=073eddfa&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073eddfa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/nodejs-standardization-global-v2.0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('073eddfa')) {
      api.createRecord('073eddfa', component.options)
    } else {
      api.reload('073eddfa', component.options)
    }
    module.hot.accept("./Google.vue?vue&type=template&id=073eddfa&scoped=true", function () {
      api.rerender('073eddfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/oauth/social/Google.vue"
export default component.exports